if (!customElements.get('freshie-feed-cart')) {
  customElements.define(
    'freshie-feed-cart',
    class FreshieFeedCart extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.onClick.bind(this));
        this.status = this.querySelector('[data-freshie-cart-status]');
      }

      async onClick(event) {
        const button = event.target.closest('[data-freshie-add], [data-freshie-add-all]');
        if (!button || button.disabled) return;

        const addAll = button.hasAttribute('data-freshie-add-all');
        const itemButtons = addAll
          ? [...this.querySelectorAll('[data-freshie-add]:not(:disabled)')]
          : [button];
        const items = itemButtons.map((itemButton) => ({
          id: Number(itemButton.dataset.variantId),
          quantity: Number(itemButton.dataset.quantity) || 1,
        }));

        if (!items.length) return;

        this.setLoading(button, true);
        this.updateStatus('');

        try {
          if (addAll) {
            await this.addAll(items);
            window.location.assign(window.routes.cart_url);
            return;
          }

          const response = await this.addOne(items[0], button);
          const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

          if (!cart) {
            window.location.assign(window.routes.cart_url);
            return;
          }

          const modal = this.closest('modal-dialog');
          const returnFocus = modal?.openedBy || button;
          cart.setActiveElement(returnFocus);
          modal?.hide();
          cart.renderContents(response);
        } catch (error) {
          this.updateStatus(error.message || 'Unable to add this item to the cart.');
        } finally {
          this.setLoading(button, false);
        }
      }

      async addOne(item, button) {
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const body = {
          id: item.id,
          quantity: item.quantity,
          sections_url: window.location.pathname,
        };

        if (cart) {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
        }

        const response = await fetch(window.routes.cart_add_url, {
          ...fetchConfig(),
          headers: { ...fetchConfig().headers, 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body),
        });
        const result = await response.json();

        if (!response.ok || result.status) {
          throw new Error(result.description || result.message || 'Unable to add this item to the cart.');
        }

        return result;
      }

      async addAll(items) {
        const response = await fetch(window.routes.cart_add_url, {
          ...fetchConfig(),
          headers: { ...fetchConfig().headers, 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items }),
        });
        const result = await response.json();

        if (!response.ok || result.status) {
          throw new Error(result.description || result.message || 'Unable to add these items to the cart.');
        }
      }

      setLoading(activeButton, loading) {
        this.querySelectorAll('[data-freshie-add], [data-freshie-add-all]').forEach((button) => {
          button.disabled = loading || button.hasAttribute('data-unavailable');
        });
        activeButton.classList.toggle('loading', loading);
        activeButton.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
      }

      updateStatus(message) {
        if (this.status) this.status.textContent = message;
      }
    }
  );
}

if (!customElements.get('freshie-feed-filter')) {
  customElements.define(
    'freshie-feed-filter',
    class FreshieFeedFilter extends HTMLElement {
      constructor() {
        super();
        this.buttons = [...this.querySelectorAll('[data-freshie-filter]')];
        this.cards = [...this.querySelectorAll('.freshie-feed__card')];
        this.status = this.querySelector('[data-freshie-results-status]');
        this.noResults = this.querySelector('[data-freshie-no-results]');
        this.resetButton = this.querySelector('[data-freshie-reset]');
        this.grid = this.querySelector('[data-freshie-grid]');

        this.addEventListener('click', this.onClick.bind(this));
      }

      connectedCallback() {
        this.sortNewestFirst();

        const requestedTag = new URLSearchParams(window.location.search).get('tag')?.toLowerCase();
        const matchingButton = this.buttons.find((button) => button.dataset.freshieFilter === requestedTag);

        if (matchingButton) this.applyFilter(requestedTag, false);
      }

      sortNewestFirst() {
        if (!this.grid) return;

        this.cards
          .sort((firstCard, secondCard) => {
            const firstDate = Date.parse(firstCard.dataset.freshieDate) || 0;
            const secondDate = Date.parse(secondCard.dataset.freshieDate) || 0;
            return secondDate - firstDate;
          })
          .forEach((card) => this.grid.appendChild(card));
      }

      onClick(event) {
        const filterButton = event.target.closest('[data-freshie-filter]');
        const resetButton = event.target.closest('[data-freshie-reset]');

        if (filterButton) this.applyFilter(filterButton.dataset.freshieFilter);
        if (resetButton) this.applyFilter('all');
      }

      applyFilter(filter, updateUrl = true) {
        let visibleCount = 0;

        this.cards.forEach((card) => {
          const tags = (card.dataset.freshieTags || '').split('|');
          const visible = filter === 'all' || tags.includes(filter);
          card.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        this.buttons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.freshieFilter === filter));
        });

        const resultLabel = visibleCount === 1 ? this.dataset.resultSingular : this.dataset.resultPlural;
        if (this.status) this.status.textContent = `${visibleCount} ${resultLabel}`;
        if (this.noResults) this.noResults.hidden = visibleCount !== 0;

        if (updateUrl) {
          const url = new URL(window.location.href);
          filter === 'all' ? url.searchParams.delete('tag') : url.searchParams.set('tag', filter);
          window.history.replaceState({}, '', url);
        }
      }
    }
  );
}
